'use strict';

var $ = require('jquery');
var _ = require('underscore');
var Marionette = require('backbone.marionette');

var ResponseView = require('./response').default;

var ResponseCollection = require('../../collections/responses').default;

export default Marionette.CollectionView.extend({

  className: 'questions-list',
  childView: ResponseView,

  events: {
    'change input': 'updateResponse',
    'change select': 'updateResponse',
    'keyup textarea': 'updateResponse',
  },

  initialize: function (options) {
    this.setupAnswers();
  },

  setupAnswers: function () {
    this.answers = {};

    var self = this;
    if (self.collection) {
      _.each(self.collection.models, function (response) {

        var passedInAnswers = self.model.get('answers');
        var questionId = response.get('question').id;

        if (passedInAnswers) {
          _.each(passedInAnswers, function (answer) {
            if (answer.qId === questionId) {
              self.answers[answer.qId] = answer;
              response.set('answer', answer);
            }
          });
        }

        if (response.has('answer')) {
          var answer = response.get('answer');

          if (answer.qId) {
            self.answers[answer.qId] = answer;
          }
        }
      });
    }

    this.model.set('answers', this.answers);
  },

  updateResponse: function (evt) {
    var $element = $(evt.currentTarget);

    var responseId = $element.prop('name').replace('\[\]', '');
    var response = this.collection.get(responseId);

    var question = response.get('question');
    var answer = response.has('answer') ? response.get('answer') : {qId: question.id, value: []};

    if (!$element.is(':checkbox')) {
      if ($element.val().length) {
        response.set('answer', answer);
        this.answers[question.id] = answer;
      } else {
        response.unset('answer');
        delete this.answers[question.id];
      }
      answer.value = $element.val();
    } else {
      if ($element.prop('checked')) {
        answer.value.push($element.val());
      } else {
        var index = answer.value.indexOf($element.val());
        answer.value.splice(index, 1);
      }

      response.set('answer', answer);
      this.answers[question.id] = answer;
    }

    this.model.set('answers', this.answers);
  },
});
